import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        height: '100%'
    },
    openAllButton: {
        margin: '0 10px 0 10px'
    },
    contentRoot: {
        paddingRight: theme.spacing(3),
        paddingLeft: theme.spacing(3),
        paddingTop: theme.spacing(2),
        height: 'calc(100% - 64px)'
    },
    equivalentPaginationContainer: {
        minHeight: '52px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'left',
        marginLeft: '16px'
    },
    tabsContainer: {
        width: '100%',
        borderRadius: '0px'
    },
    paper: {
        width: '100%',
        height: '100%'
    },
    tabsFlexContainer: {
        justifyContent: 'space-around'
    },
    siteName: {
        fontFamily: 'roboto',
        fontSize: '14px'
    },
    siteNameContainer: {
        display: 'flex',
        flexDirection: 'row',
        paddingLeft: theme.spacing(1),
        margin: 0,
        backgroundColor: theme.palette.grey.light,
        alignItems: 'center'
    },
    siteInformation: {
        fontFamily: 'roboto',
        fontSize: '12px',
        marginLeft: theme.spacing(1)
    },
    tablesContainer: {
        height: 'calc(100% - 162px)',
        overflow: 'auto'
    },
    loadingContainer: {
        height: 'calc(100% - 162px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    hide: {
        height: 0,
        overflow: 'hidden',
    },
    filtersBar: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '5px'
    },
    formControlMode: {
        minWidth: '120px',
        marginRight: '4px'
    },
    noResultContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'calc(100% - 139px)',
        overflow: 'auto',
        fontFamily: 'roboto',
        fontSize: '25px'
    },
    tabCategory: {
        padding: '10px'
    },
    tabs: {
        justifyContent: 'space-between'
    }
}));

export default useStyles;
